import { SubmittedFormItems } from 'flows/forward-mail/components/SubmittedFormItems';
import { PAGE } from 'flows/forward-mail/constants/analytics-tracker';
import { useFYMBaseDataStore } from 'flows/forward-mail/store';
import { useDataForCards } from 'flows/core/hooks/use-data-for-cards';

export const FYMReceipts = () => {
  const { data } = useDataForCards();
  const { formData: submittedForms } = useFYMBaseDataStore();
  return (
    <SubmittedFormItems
      dataForCards={data}
      submittedForms={submittedForms}
      onItemClickTrackPage={PAGE.ENTRY_POINT}
    />
  );
};
